import React, { Component } from 'react';
import axios from 'axios';
// component
import Header from './components/Header'
import About from './components/About'
import loader from './logo.png'

const API_URL = process.env.REACT_APP_API_URL || "https://api.glyphstats.com/api/";


class AutoglyphDetails extends Component{

	constructor(props) {
	    super(props);

	    this.state = {
	    	autoglyph_id: this.props.match.params.id,
	    	autoglyph : {},
	    	autoglyph_image: {},
	    	symmetry: "",
	    	symbol_scheme: {},
	    	symbole_distribution_img: [],
	    	similar_images: [],
	    	symbole_distribution: [],
			loading:true,
			notFound:false

	    }
	  }

	componentDidMount(){
		this.fetchAutoglyph(this.props.match.params.id)
	}

	componentDidUpdate(prevProps){
		if (prevProps.match.params.id !== this.props.match.params.id) {
			this.setState({ loading: true, notFound: false })
			this.fetchAutoglyph(this.props.match.params.id)
		}
	}

	fetchAutoglyph(id){
		axios.get(API_URL + 'autoglyphs/' + id + '/')
        .then(response => {
        	const symbole_distribution_img = [];
        	
			this.setState({ symbole_distribution_img: symbole_distribution_img})
        	this.setState({ autoglyph: response.data })
        	this.setState({ autoglyph_image: response.data.autoglyph_image })
        	this.setState({ symbol_scheme: response.data.symbol_scheme })
        	this.setState({ similar_images: response.data.similar_images })
        	this.setState({ symbole_distribution: response.data.symbole_distribution})
			
        	let symmetryData = response.data.symmetry
        	delete(symmetryData['id'])
        	delete(symmetryData['image'])
        	let symmetry = ""

       		Object.keys(response.data.symmetry).forEach((key) => {
   				if (symmetryData[key] === 1){
   					if (key === "x_axes_oe_angle"){
   						symmetry = symmetry + "X-Axis|"
   					}
   					if (key === "y_axes_n_angle"){
   						symmetry = symmetry + "Y-Axis|"
   					}
   					if (key === "none"){
   						symmetry = symmetry + "None|"
   					}
   					if (key === "diagonal_otf_angle"){
   						symmetry = symmetry + "Diagonal (135)|"
   					}
   					if (key === "diagonal_ff_angle"){
   						symmetry = symmetry + "Diagonal (45)|"
   					}
   					if (key === "all"){
   						symmetry = symmetry + "All|"
   					}
   				}
       		})

       		symmetry = symmetry.replace("|", ", ")
       		symmetry = symmetry.replace("|", "")
        	this.setState({ symmetry: symmetry })
			this.setState({loading:false})

        })
        .catch(err => {
        	if (err.response && err.response.status === 404) {
        		this.setState({ loading: false, notFound: true })
        	} else {
        		this.setState({ loading: false })
        	}
        });

	}


	handleClick=(e,id)=>{
		this.props.history.push(`/autoglyph-details/${id}`)
	}


	render(){

		const autoglyph = this.state.autoglyph;

		const toggleAbout = () => {
			this.setState({isAboutActive: !this.state.isAboutActive})
		
		}

		const defineSymbol = (symbol) => {
			if(symbol === ".") {
				return '/static/media/dot.5d2da7bf.svg'
			} else {
				return null
			}
		}

		if (this.state.notFound) {
			return(
				<div>
					<Header
						search={false}
						buttons={false}
						display_searchbar={false}
						toggleAbout={toggleAbout.bind(this)}
						glyphClose={true}
					/>
					<div className="parent_detail" style={{padding: "40px", textAlign: "center"}}>
						<h2>Autoglyph #{this.state.autoglyph_id} not found</h2>
						<p>This Autoglyph doesn't exist. Try going back to the gallery.</p>
						<a className="btn" href="/">Back to gallery</a>
					</div>
					<About isActive={this.state.isAboutActive} toggleAbout={toggleAbout.bind(this)}/>
				</div>
			)
		}

		return(
			<div>
			<Header
					search={false}
					buttons={false}
					display_searchbar={false}
					toggleAbout={toggleAbout.bind(this)}
					glyphClose={true}
				/>
				<div className="parent_detail">
					<div className="left_detail">
						<div className="detail_sub"><strong><h3>{autoglyph.autoglyph_number}</h3></strong></div>
						
						<div className="glyph_detail_row">
							<div className="glyph_detail_title">Rarity Score</div>
							<div className="glyph_detail_value">
								{autoglyph.rarity_score}
								<small>({this.state.autoglyph_image.rarity_score} out of 512)</small>
							</div>
						</div>
					
						<div className="glyph_detail_row">
							<div className="glyph_detail_title">Symbol Scheme</div>
							<div className="glyph_detail_value">
								#{this.state.symbol_scheme.pattern_number}
								<img
								className="pattern_image"
								src={`${this.state.symbol_scheme.pattern}`}
								style={{"height": '15px'}}
								alt="Symbol scheme"/>
							</div>
						</div>

						<div className="glyph_detail_row">
							<div className="glyph_detail_title">Symmetry</div>
							<div className="glyph_detail_value">{this.state.symmetry}</div>
						</div>
						
						<div className="glyph_detail_row column">
							<div className="glyph_detail_title">Symbol Distribution</div>
							<div className="glyph_detail_value">
								{this.state.symbole_distribution.map((item) => (
									<span className="glyph_detail_wrap" key={item.symbol}>
										{ defineSymbol(item.symbol) ? <img src={`${defineSymbol(item.symbol)}`} width="15" alt="" /> : item.symbol }
									<small>({item.count}, {Math.ceil(item.value)}%)</small></span>
								))} 
							</div>
						</div>
						
						<div className="glyph_detail_row cluster">
							<div className="glyph_detail_title">Cluster</div>
							<div className="glyph_detail_value">
								{autoglyph.cluster} <small className="glyph_cluster_small">{autoglyph.cluster_autoglyphs} Autoglyphs are in this cluster</small>
							</div>
						</div>
						
						<a target="_blank" className="btn" href={`${autoglyph.opensea_link}`}>View on Opensea</a>
								
					</div>
					<div className="right_detail">
						{
						this.state.autoglyph ? 
						<span>
							<img
				    		src={`${this.state.autoglyph_image.autoglyph_image}`}
				    		alt="Autoglyph" className='autoglyph-image-main'/>
							
						</span>
						:

						<div>No details found</div>

					}
					</div>
				</div>
					
				<div className="similar_images">
					<h2>Similar Autoglyphs from the Cluster</h2>
					<div className="similar_images_list">

					{this.state.loading && 	<img
			    				 className='similar'
			    				src={loader} alt=""
								/>}
			    	{
			    	!this.state.loading &&	this.state.similar_images.map((image, index) =>(
			    		index < 5 &&
						
			    				<img
			    				 className='similar-image'
			    				src={`${image.autoglyph_image}`} alt="Similar autoglyph"
								onClick={e=>this.handleClick(e,image.id)}
								key={image.id}
								/>
					
			    		))
			    	}

					</div>
				</div>
				<About isActive={this.state.isAboutActive} toggleAbout={toggleAbout.bind(this)}/>
			</div>
		)
	}
}




export default AutoglyphDetails;


// WEBPACK FOOTER //
// ./src/AutoglyphDetails.js